import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=61f0a0a6&scoped=true&"
import script from "./ReportsTable.vue?vue&type=script&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=61f0a0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0a0a6",
  null
  
)

export default component.exports